import type { GetThemeNormalized as Theme } from '@messenger/types'
import i18n from 'i18next'
import { DEFAULT_FONT_COLOR } from '@messenger/consts'

// @TODO: fix this type, hotfix for now
type IncludeSnakeCaseInTheme = Theme & {
  font_color: string | null
  font_color_accent1: string | null
  font_color_accent2: string | null
}

export const fontColors = (props: {
  selectedTheme: IncludeSnakeCaseInTheme
}) => {
  const { selectedTheme } = props

  const THEME_COLORS = {
    main: {
      value: selectedTheme?.font_color || null,
      label: i18n.t('editor.tinyMCE.themeColor'),
    },
    accent1: {
      value: selectedTheme?.font_color_accent1 || null,
      label: i18n.t('editor.tinyMCE.accent1'),
    },
    accent2: {
      value: selectedTheme?.font_color_accent2 || null,
      label: i18n.t('editor.tinyMCE.accent2'),
    },
  }

  const customColorsMap = Object.entries(THEME_COLORS)
    .filter(([, color]) => !!color.value)
    .flatMap(([, color]) => [color.value, color.label])

  return [
    '#BFEDD2',
    'Light Green',
    '#FBEEB8',
    'Light Yellow',
    '#F8CAC6',
    'Light Red',
    '#ECCAFA',
    'Light Purple',
    '#C2E0F4',
    'Light Blue',

    '#2DC26B',
    'Green',
    '#F1C40F',
    'Yellow',
    '#E03E2D',
    'Red',
    '#B96AD9',
    'Purple',
    '#3598DB',
    'Blue',

    '#169179',
    'Dark Turquoise',
    '#E67E23',
    'Orange',
    '#BA372A',
    'Dark Red',
    '#843FA1',
    'Dark Purple',
    '#236FA1',
    'Dark Blue',

    '#ECF0F1',
    'Light Gray',
    '#CED4D9',
    'Medium Gray',
    '#95A5A6',
    'Gray',
    '#7E8C8D',
    'Dark Gray',
    '#34495E',
    'Navy Blue',

    DEFAULT_FONT_COLOR,
    'Black',
    '#ffffff',
    'White',
    ...customColorsMap,
  ]
}

export default fontColors
